import z from "zod";

export const NotificationSchema = z.object({
  title: z.string().optional(),
  text: z.string(),
  expectSideEffect: z.boolean().optional(),
  persistent: z.boolean().optional(),
  type: z.enum(["info", "error", "success"]),
  extarnalUse: z.boolean().optional(),
  id: z.number().optional(),
});
